module.exports = __webpack_public_path__ + "static/media/jewelry.1fa382dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/jewelry.svg
// module id = 3061
// module chunks = 0